import React from "react";
type FormFieldProps = {
  id: string;
  label: string;
  required?: boolean;
  error?: string | null;
  className?: string;
  children: React.ReactNode;
};
export function FormField({
  id,
  label,
  required,
  error,
  className = "",
  children
}: FormFieldProps) {
  return <div className={className} data-id="element-184" data-mp="25dohr8gnzwlc">
      <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-white/90" data-id="element-185" data-mp="25df14bhif1sb">
        {label}
        {required && <span className="ml-0.5 text-gold" aria-hidden="true" data-id="element-186" data-mp="2k9nzzbxhnd47">*</span>}
      </label>
      {children}
      {error && <p id={`${id}-error`} role="alert" className="mt-1.5 text-xs font-medium text-red-300" data-id="element-187" data-mp="2fbm6ry6clxf0">
          {error}
        </p>}
    </div>;
}